module.exports = __webpack_public_path__ + "static/media/fly0246.8a162fc1.webp";